export enum EAlertType {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export interface IAlert {
  show: boolean;
  message: string | null;
  type: string;
  hideInSeconds?: number;
  version?: string;
}

export interface IAlertAction {
  type: string;
  payload: IAlert;
}

export type TAlertIconMap = {
  name: string;
  color: string;
};
